import { SettingsView } from "../../components/embedded/settings";

const Settings = SettingsView;

const SettingsExpanded = () => (
  <div className="h-screen w-screen overflow-hidden relative">
    <SettingsView expanded />
  </div>
);

export { Settings, SettingsExpanded };
